


















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ScoreService } from "@/services/score-service";
import { Score } from '@/model/score';
import { Prize } from '@/model/prize';
import DatePicker from "vue2-datepicker";
import { signIn, signOut, signedIn, authManager} from '../utils/login';
import * as Constants from '@/utils/constants';


@Component({
    components: {
        DatePicker
    }
})
export default class PrizesList extends Vue {
    // data
    error: any = null;
    loading: boolean = false;
    dismissSecs: number = 10;
    dismissCountDown: number = 0;
    showDismissibleAlertA: boolean = false;
    showDismissibleAlertDelete: boolean = false;
    currentPage: number = 1;
    perPage: number = 10;
    pageOptions: Array<number> = [ 10, 25, 50 ];
    sortBy: any = null;
    sortDesc: any = false;
    filter: any = null;
    mockStartDate: Date = new Date();
    mockEndDate!: Date;

    prizeToAdd: Prize = new Prize();
    prizeToDelete: Prize = new Prize();
    prizeImage: any = null;
    prizes: Array<Prize> = [];
    fields: Array<object> = [
        // { key: "id", label: "Id", sortable: true },
        { key: "title", label: "Titolo", sortable: true, class:"capitalize" },
        { key: "value", label: "Punti", sortable: true },
        // { key: "description", label: "Descrizione"},
        { key: "startDate", label: "Data Inizio", sortable: true, },
        { key: "endDate", label: "Data Fine", sortable: true, },
        { key: "actions", label: "Azioni", sortable: false },
        // { key: "delete", label: "Cancella", sortable: false},
    ];

    token: string = "";

    @Prop()
    user: any;

    prizesListService: ScoreService = new ScoreService();

    // computed
    get prizeImageName(): string {
        if (this.prizeImage && this.prizeImage.name) {
            return this.prizeImage.name;
        } else {
            return "nessuna";
        }
    }

    get isValidForm(): boolean {
        return this.prizeToAdd.title != '' 
            && this.prizeToAdd.description != ''
            && this.prizeToAdd.value > 0
            && this.prizeToAdd.startDate
            && this.prizeToAdd.ordBy > 0;
    }

      // computed
    get totalPrizes() {
        return this.prizes ? this.prizes.length : 0;
    }
    
    get longPrizeList() {
        return this.prizes && this.prizes.length > 10
    }

    // methods
    getPrizesList() {
        this.prizesListService.getAllPrizes(this.token).then((pzs: any) => {
            this.prizes = pzs;
        })
    }

    countDownChanged(dismissCountDown: number) {
      this.dismissCountDown = dismissCountDown
    }

    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }

    clearFormValues() {
        this.prizeToAdd = new Prize();
    }

    addPrize() {
        this.prizesListService.addPrize(this.prizeToAdd, this.token).then((response) => {
            if(response.status === 201) {
                const prizeId: string = response.data.id;
                if (this.prizeImage) {
                    this.prizesListService.uploadPrizeImage(prizeId, this.prizeImage, this.token)
                    .then((response) => {
                        if (response.status === 201) {
                            console.log("Prize image uploaded.");
                        } else {
                            console.log("Response status: " + response.status);
                        } 
                    })
                    .catch((e) => {
                        alert("Errore in caricamento immagine: " + e.message);
                    })
                }
                
                this.getPrizesList();
                // if there is a prize image, upload it, then set back to null
                console.log("Ottimo!");
                this.showDismissibleAlertA = true;
                this.dismissCountDown = 300;
            } else {
                console.log("Errore!")
                this.showDismissibleAlertA = false;
            }
        })
        .catch(e => {
            console.log
        })
    }

    deletePrize() {
        this.prizesListService.deletePrize(this.prizeToDelete, this.token).then((response) => {
            if(response.status === 200) {
                this.getPrizesList();
                console.log("Ottimo!");
                this.showDismissibleAlertDelete = true;
                this.dismissCountDown = 300;
            } else {
                console.log("Errore!")
                this.showDismissibleAlertDelete = false;
            }
        })
    }

    setItemToDelete(prize: Prize) {
        this.prizeToDelete = prize;
    }

    
    created() {
        this.token = this.user.access_token;
        this.getPrizesList();
    }

    // computed
    get isSignedIn() {
      return this.user !== null;
    }

    get isAdmin() {
      return this.user.profile.roles.indexOf(Constants.ADMIN_ROLE) > -1;
    }
}

